import { AxiosError } from 'axios';
import { showNotification } from '../../common/actionCreators/dispatchNotification';
import apiClient from '../../common/api/apiClient';
import { ApiError } from '../../common/api/apiResponse';
import { UserDto } from './users.dtos';

const usersUrl = '/users/';

export const getUsersApi = async () => {
    return await apiClient.get(usersUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving users.', 'error');
        }
        throw err;
    });
};

export const getUserApi = async (request: string) => {
    return await apiClient.get(usersUrl + request)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving user.', 'error');
        }
        throw err;
    });
};

export const updateUserApi = async (request: UserDto) => {
    return await apiClient.put(usersUrl, request)
      .then((res) => {
        showNotification("User updated", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while updating user.', 'error');
        }
        throw err;
      });
};

export const createUserApi = async (request: UserDto) => {  
    return await apiClient.post(usersUrl, request)
      .then((res) => {
        showNotification("User created", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while creating user.', 'error');
        }
        throw err;
      });
};